import { webmasterConstants } from '../constants/webmaster';
import { sitesConstants } from '../constants/sites';
import { isNil } from '../utils/utils';

import { dashboardSettings3, dashboardSettings, defaultLocale } from '../config';

const initialState = {
  unreadTicketsCount: 0,
  dashboardSettings,
  profile: {
    language: defaultLocale,
    banned: false,
    two_factor: {},
    justRegistered: {
      is: false,
      popupAmount: 0,
      hasStream: false,
      hasOffer: false,
      hasLead: false,
    },
  },
  bots: { 0: {} },
  tour: {},
};

const getDefaultDashboardSettings = theme => dashboardSettings;

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case webmasterConstants.LOGIN_SUCCESS:
      const profileWithCoins = action.profile.store
        ? action.profile
        : {
            ...action.profile,
            store: {
              coins: 0,
            },
          };
      const avatarURL = action.isAvatarUpdate
        ? action.profile.img + `?${new Date().getTime()}`
        : action.profile.img;

      return {
        ...state,
        isAuthenticated: true,
        profile: {
          ...state.profile,
          ...profileWithCoins,
          img: avatarURL,
          // documents: true,
          // auth_type не приходит в ответе от апи,
          // но должен быть отправлен при редактировании профиля
          // чтобы не слетала двухфакторная авторизация
          auth_type: action.profile.two_factor ? action.profile.two_factor.type : 0,
          // theme: 3,
        },
        dashboardSettings: getDefaultDashboardSettings(action.profile.theme),
        isSlave: !!profileWithCoins.master.slave,
        two_factor: action.profile.two_factor,
      };

    case webmasterConstants.LOGIN_FAILURE:
    case webmasterConstants.START_LOGOUT:
      return {
        ...state,
        logoutFetching: true,
      };
    case webmasterConstants.LOGOUT:
      return {
        ...initialState,
        logoutFetching: true,
      };
    case webmasterConstants.SET_BALANCE_SUCCESS:
      return {
        ...state,
        balance: action.balance,
      };

    case webmasterConstants.SET_NEWS_LIST_SUCCESS:
      return {
        ...state,
        news: action.news,
      };

    case webmasterConstants.SET_NEWS_LIST_FAILURE:
      return {
        ...state,
        news: [],
      };

    case webmasterConstants.SET_OFFERS_LIST_SUCCESS:
      return {
        ...state,
        offers: action.offers,
      };

    case webmasterConstants.SET_OFFERS_LIST_FAILURE:
      return {
        ...state,
        offers: [],
      };

    case webmasterConstants.SET_MANAGER_SUCCESS:
      return {
        ...state,
        manager: action.manager,
      };

    case sitesConstants.SET_SITES_SUCCESS:
      return {
        ...state,
        sites: action.sites,
      };

    case sitesConstants.EDIT_SITE_SUCCESS:
      return {
        ...state,
        sites: state.sites.map(site => {
          if (site.id === action.id) {
            return {
              ...site,
              ...action.updates,
            };
          } else {
            return site;
          }
        }),
      };

    case sitesConstants.REMOVE_SITE_SUCCESS:
      return {
        ...state,
        sites: state.sites.filter(({ id }) => id !== action.id),
      };

    case webmasterConstants.SET_WALLETS_SUCCESS:
      return {
        ...state,
        wallets: action.wallets,
      };

    case webmasterConstants.SET_DASHBOARD_SETTINGS_SUCCESS:
      try {
        const settings = Array.isArray(action.settings)
          ? action.settings
          : JSON.parse(action.settings);

        const defaultSettings = getDefaultDashboardSettings(state.profile.theme);

        const mergedSettings = defaultSettings.map(item => {
          for (let i = 0; i < settings.length; i++) {
            if (settings[i].id === item.id) {
              return settings[i];
            }
          }
          return item;
        });

        return {
          ...state,
          dashboardSettings: isNil(settings) ? defaultSettings : mergedSettings,
        };
      } catch (error) {
        return {
          ...state,
          dashboardSettings: defaultSettings,
        };
      }

    case webmasterConstants.SET_UNREAD_TICKETS_SUCCESS:
      return {
        ...state,
        unreadTicketsCount: action.count,
      };

    case webmasterConstants.SET_SOCIAL_ACCOUNT_SUCCESS:
      return {
        ...state,
        profile: {
          ...state.profile,
          socials: [...state.profile.socials, action.account],
        },
      };

    case webmasterConstants.REMOVE_SOCIAL_ACCOUNT_SUCCESS:
      return {
        ...state,
        profile: {
          ...state.profile,
          socials: state.profile.socials.filter(({ id }) => id !== action.accountId),
        },
      };

    case webmasterConstants.SET_TOUR_STEP:
      return {
        ...state,
        tour: {
          ...state.tour,
          step: action.index,
          openMenu: action.openMenu,
        },
      };

    case webmasterConstants.SET_NOVICE_POPUP_AMOUNT_SUCCESS:
      // console.log(action.amount)
      return {
        ...state,
        profile: {
          ...state.profile,
          justRegistered: {
            ...state.profile.justRegistered,
            popupAmount: action.amount,
          },
        },
      };

    case webmasterConstants.SET_BOTS_INFO_SUCCESS:
      return {
        ...state,
        bots: {
          ...state.bots,
          ...action.bots,
        },
      };

    case webmasterConstants.SET_JUST_REGISTERED_HAS_OFFER:
      return {
        ...state,
        profile: {
          ...state.profile,
          justRegistered: {
            ...state.profile.justRegistered,
            hasOffer: true,
          },
        },
      };

    case webmasterConstants.SET_JUST_REGISTERED_HAS_STREAM:
      return {
        ...state,
        profile: {
          ...state.profile,
          justRegistered: {
            ...state.profile.justRegistered,
            hasStream: true,
          },
        },
      };

    default:
      return state;
  }
};
